module.exports = __webpack_public_path__ + "img/réalisation d_une verrière d_intérieur avec porte coulissante.29c72b98.jpg";